import React from 'react';
import GenePage from '../../components/GenePage';
import NotFound from '../not-found/NotFound';
import Layout from '../../components/Layout';
import GeneLandingPage from '../../components/GeneLandingPage';

import { TITLE } from '../../settings';

const geneHeader = {
  showSearch: true,
  showTutorial: true,
};

async function _main(fetch, gstrs, integration) {
  let component = null;
  let title = '';
  if (gstrs.length) {
    title = `Gene Networks - ${TITLE}`;
    component = (
      <Layout headerOptions={geneHeader}>
        <GenePage gstrs={gstrs} defaultIntegration={integration} />
      </Layout>
    );
    return { title, component };
  }

  component = (
    <Layout>
      <NotFound title="Gene Not Found" />
    </Layout>
  );
  title = 'Gene Not Found';
  return { title, component };
}

function action({ fetch, data, params }) {
  if (data && data.entrez) {
    const gstrs = data.entrez;
    return _main(fetch, gstrs);
  }
  if (params && params.integration) {
    const gstrs = params.ids.split('+');
    return _main(fetch, gstrs, params.integration);
  }
  if (params && params.ids) {
    const gstrs = params.ids.split('+');
    return _main(fetch, gstrs);
  }
  const component = (
    <Layout>
      <GeneLandingPage />
    </Layout>
  );
  const title = `${TITLE} Gene Networks`;
  return { title, component, chunks: ['gene'] };
}

export default action;
